export * from './ArrowDUturnLeftDownIcon';
export * from './ArrowDUturnLeftDownIcon16Light';
export * from './ArrowDUturnLeftDownIcon16Regular';
export * from './ArrowDUturnLeftDownIcon16Solid';
export * from './ArrowDUturnLeftDownIcon20Light';
export * from './ArrowDUturnLeftDownIcon20Regular';
export * from './ArrowDUturnLeftDownIcon20Solid';
export * from './ArrowDUturnLeftDownIcon24Regular';
export * from './ArrowDUturnLeftDownIcon24Solid';
export * from './ArrowDUturnLeftDownIcon32Regular';
export * from './ArrowDUturnLeftDownIcon64Regular';
